import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { taskId: String }

  connect() {
    console.log('Business Pulse Controller connected')
    
    // If a task ID is present, automatically open the task modal after a short delay
    // to allow the page to fully load
    if (this.hasTaskIdValue) {
      setTimeout(() => {
        this.openTaskModal()
      }, 500)
    }
  }

  disconnect() {
  }

  async openTaskModal() {
    try {
      // Find the task frame in the tasks turbo frame
      const tasksFrame = document.getElementById('tasks')
      if (tasksFrame) {
        // Look for the task link with the matching task ID
        const taskLink = tasksFrame.querySelector(`a[href*="${this.taskIdValue}"]`)
        if (taskLink) {
          // Programmatically click the task link to open the modal
          taskLink.click()
        } else {
          console.warn(`Task with ID ${this.taskIdValue} not found in tasks list`)
        }
      }
    } catch (error) {
      console.error('Error opening task modal:', error)
    }
  }
}
